export default __webpack_public_path__ + "static/media/promo_07.76cc98e9.jpg";